import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  image: string;
  author: string;
  date: string;
  readCount: string;
  category: string;
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  image,
  author,
  date,
  readCount,
  category,
}: ArticleCardProps) {
  return (
    <Link
      to={`/article/${slug}`}
      className="group cursor-pointer flex flex-col sm:flex-row gap-5 p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
    >
      <div className="w-full sm:w-[200px] flex-shrink-0 aspect-[16/10] sm:aspect-[4/3] overflow-hidden rounded-lg bg-background-200">
        <img
          src={image}
          alt={title}
          title={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
      </div>
      <div className="flex flex-col justify-between flex-1 min-w-0">
        <div>
          <div className="flex items-center gap-3 mb-2 flex-wrap">
            <span className="px-2.5 py-0.5 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full">
              {category}
            </span>
            <span className="text-xs text-foreground-400">{date}</span>
          </div>
          <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
            {title}
          </h3>
          <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
            {excerpt}
          </p>
        </div>
        <div className="flex items-center gap-4 mt-3 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-user-line"></i>
            {author}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {readCount} 阅读
          </span>
        </div>
      </div>
    </Link>
  );
}